function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/** A date and time in ISO format (eg. "2024-12-09T07:17:52+00:00") */

/**
 * The content of a mention tag that the backend "discarded" as invalid.
 * Possible reasons are: the user does not exist, belongs to a different group,
 * is nipsa'd, etc.
 */

/**
 * Whether mentions should be done via username (`@username`) or display name
 * (`@[Display Name]`).
 *
 * This also affects the information displayed in suggestions, which will not
 * include the username in the second case.
 */

/**
 * Replace an unprocessed mention tag with another element that represents the
 * proper type of mention ('link', 'no-link' or 'invalid').
 */
function processAndReplaceMention(unprocessedMention, mention, mentionMode) {
  var _unprocessedMention$t;
  var originalTagContent = (_unprocessedMention$t = unprocessedMention.textContent) !== null && _unprocessedMention$t !== void 0 ? _unprocessedMention$t : '';
  var mentionOrInvalidContent = mention !== null && mention !== void 0 ? mention : originalTagContent;

  // If this mention element has already been processed, return as is
  if (unprocessedMention.hasAttribute('data-hyp-mention-type')) {
    return [unprocessedMention, mentionOrInvalidContent];
  }
  var type = mention && mention.link ? 'link' : mention ? 'no-link' : 'invalid';
  var processedMention = document.createElement(type === 'link' ? 'a' : 'span');
  processedMention.setAttribute('data-hyp-mention', '');
  processedMention.setAttribute('data-hyp-mention-type', type);

  // For valid mentions, resolve the most recent username or display name, in
  // case it has changed since the mention was created.
  // The only exception is when a valid mention with an empty display name is
  // resolved, in which case we fall back to the original tag content.
  if (!mention) {
    processedMention.textContent = originalTagContent;
  } else if (mentionMode === 'username') {
    processedMention.textContent = "@".concat(mention.username);
  } else {
    processedMention.textContent = mention.display_name ? "@".concat(mention.display_name) : originalTagContent;
  }
  if (type === 'link') {
    var _mention$link;
    // If the mention exists in the list of mentions and contains a link, render
    // it as an anchor pointing to that link
    processedMention.setAttribute('href', (_mention$link = mention === null || mention === void 0 ? void 0 : mention.link) !== null && _mention$link !== void 0 ? _mention$link : '');
    processedMention.setAttribute('target', '_blank');
  }
  if (type !== 'invalid') {
    var _unprocessedMention$d;
    processedMention.setAttribute('data-userid', (_unprocessedMention$d = unprocessedMention.dataset.userid) !== null && _unprocessedMention$d !== void 0 ? _unprocessedMention$d : '');
  }
  unprocessedMention.replaceWith(processedMention);
  return [processedMention, mentionOrInvalidContent];
}

/**
 * Search for mention tags inside an HTML element, and try to match them with a
 * provided list of mentions. Every matched element will be replaced with
 * another one that represents the proper type of mention ('link', 'no-link' or
 * 'invalid').
 *
 * @return - Map of HTML elements that matched a mention tag, with their
 *           corresponding mention or invalid username
 */
export function processAndReplaceMentionElements(element, mentions, mentionMode) {
  var mentionElements = element.querySelectorAll('[data-hyp-mention]');
  var foundMentions = new Map();
  var _iterator = _createForOfIteratorHelper(mentionElements),
    _step;
  try {
    var _loop = function _loop() {
      var mentionElement = _step.value;
      var htmlMentionElement = mentionElement;
      var mentionUserId = htmlMentionElement.dataset.userid;
      var mention = mentionUserId ? mentions.find(function (m) {
        return m.userid === mentionUserId;
      }) : undefined;
      foundMentions.set.apply(foundMentions, _toConsumableArray(processAndReplaceMention(htmlMentionElement, mention, mentionMode)));
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return foundMentions;
}
//# sourceMappingURL=mentions.js.map